import React, { useState, useEffect } from 'react';
import autopathIcon from '../assets/autopath-icon.svg';
// import loginIllustration from '../assets/login-illustration.svg';
import loginIllustration2 from '../assets/login-illustration2.png';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  // useEffect(() => {
  //   const img = new Image();
  //   img.src = loginIllustration;
  //   img.onload = () => setImageLoaded(true);
  //   img.onerror = () => setImageLoaded(true); // Fallback to loginIllustration2 if load fails
  // }, [loginIllustration]);

  return (
    <div className='flex h-screen'>
      {/* Left side - illustration */}
      <div className='w-1/2 h-full'>
        {/* {imageLoaded ? (
          <img
            src={loginIllustration}
            alt='Login illustration'
            className='w-full h-full object-cover'
          />
        ) : ( */}
        <img
          src={loginIllustration2}
          alt='Login illustration'
          className='w-full h-full object-cover'
        />
        {/* )} */}
      </div>
      {/* Right side - form */}
      <div className='w-1/2 flex items-center justify-center bg-white'>
        <div className='w-full max-w-md px-6'>
          <div className='flex justify-center mb-6'>
            <img
              src={autopathIcon}
              alt='Autopath logo'
              className='h-10 w-10'
              onError={(e) => {
                e.currentTarget.src = '/path/to/fallback-image.png'; // Add a fallback for autopathIcon
              }}
            />
          </div>
          <h2 className='text-center text-2xl font-semibold mb-8'>{title}</h2>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
